import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: false,
    name: 'keyValues'
})
export class KeyValuesPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        const keys = [];
        for (const key in value) {
            if (Object.prototype.hasOwnProperty.call(value, key)) {
                keys.push({ key: key, value: value[key] });
            }
        }
        return keys;
    }
}
